export default "__VITE_ASSET__C98p7dOc__"